import { Link } from 'react-router-dom';
import { config } from '../../utils/config';
import { Button } from '../button/button';
import { Heading } from '../heading/heading';
import { Actions, Content, Copy, Form, Host, Sticky } from './shared';
import useActiveYear from '../../hooks/useActiveYear';

export const NoTransactionalAccount = ({
  clientData,
  error,
}: {
  clientData: any;
  error: any;
}) => {
  const ACTIVE_YEAR = useActiveYear();

  const url = `${config.registerUrl}?redirect=${encodeURIComponent(
    `${window.location.origin}/register`
  )}&origin=sothebys-napa`;
  const isBasicAccount = !!clientData?.basicUserStatus?.id;
  const isDowngradedAccount = !!clientData?.downgradedUserStatus?.id;
  const downgradeReason = clientData?.downgradedUserStatus?.reason;

  let messaging;
  let header = 'Complete your profile';
  if (
    error?.graphQLErrors?.find(
      (e: any) => e?.extensions?.code === 'NON_TRANSACTIONAL_USER_ERROR'
    )
  ) {
    messaging =
      'To participate in the auction you need to complete your profile with Sotheby’s.';
  } else if (error) {
    header = 'Action needed';
    messaging = `Something went wrong. Please try again.`;
  }

  if (isBasicAccount) {
    messaging =
      'To participate in the auction you need to complete your profile with Sotheby’s.';
  } else {
    if (isDowngradedAccount) {
      header = 'Action needed';
      if (downgradeReason === 'MissingInformation') {
        messaging =
          'In order to participate in the auction please take a moment to update your profile.';
      } else {
        messaging =
          'There is an issue with your account which prevents you from bidding at this time.';
      }
    }
  }

  return (
    <Host>
      <Content>
        <Heading center>{header}</Heading>
        <Copy>{messaging || 'Something went wrong. Please try again.'}</Copy>
        <span title="error" hidden style={{ display: 'none' }}>
          {error?.message}
        </span>
        <br />
        <Button fullWidth as="a" href={url}>
          Continue on Sotheby’s
        </Button>
      </Content>
      <Sticky>
        <Form>
          <Actions>
            <Button as={Link} variant="secondary" to={`/${ACTIVE_YEAR}/lots`}>
              Cancel
            </Button>
          </Actions>
        </Form>
      </Sticky>
    </Host>
  );
};
